import React, { useEffect, useState } from "react";
import { ResponsiveContainer } from "recharts";
import ChartPieDonut from "../../components/DonutChart/DonutChart.tsx";
import { useExpenseByCategory } from "../../hooks/useExpenseByCategory.tsx";
import { useExchangeRates } from "../../hooks/useExchangeRates.tsx";

export default function SpendingBreakdown() {
  const [expenseByCategory, setExpensesByCategory] = useState([]);
  const BASE_CURRENCY = (() => {
    try {
      return localStorage.getItem("pref:baseCurrency") || "AED";
    } catch {
      return "AED";
    }
  })();

  const expensesByCategory = useExpenseByCategory();
  const { rates } = useExchangeRates(BASE_CURRENCY);

  useEffect(() => {
    const getBaseAmount = (amount: number, fromCurrency: string): number => {
      if (!rates || !rates[fromCurrency]) return 0;
      return (
        amount * (rates[BASE_CURRENCY.toLowerCase()] / rates[fromCurrency])
      );
    };

    expensesByCategory.transactions.forEach((n: any) => {
      n.total = getBaseAmount(n.totalAmount, n.currency);
    });

    setExpensesByCategory(expensesByCategory.transactions);
  }, [rates, expensesByCategory, BASE_CURRENCY]);

  return (
    <div>
      <div className="h-64">
        <ResponsiveContainer width="100%" height="100%">
          <ChartPieDonut chartData={expenseByCategory} />
        </ResponsiveContainer>
      </div>
    </div>
  );
}
